import { Injectable, inject } from '@angular/core';
import { RegistrationApi } from '../data-access/registration-api.service';
import { RegistrationQuote } from '../domain/registration-command';

/** Component lifetime: current plan/date/payment only; stale requests cannot publish. */
@Injectable()
export class RegistrationQuoteState {
  private readonly api = inject(RegistrationApi);
  private generation = 0;
  private key = '';
  loading = false;
  error = '';
  value: RegistrationQuote | null = null;
  clear(): void { ++this.generation; this.key = ''; this.loading = false; this.error = ''; this.value = null; }
  async load(plan: number, start: string, payment: string): Promise<RegistrationQuote | null> {
    const key = `${plan}/${start}/${payment}`;
    if (this.key === key && this.value) return this.value;
    const generation = ++this.generation;
    this.key = key; this.value = null; this.loading = true; this.error = '';
    try {
      const quote = await this.api.quote(plan, start, payment);
      if (generation !== this.generation) return null;
      this.value = quote; return quote;
    } catch {
      if (generation === this.generation) this.error = '初回請求額を取得できませんでした。入力を確認し、再取得してください。';
      return null;
    } finally { if (generation === this.generation) this.loading = false; }
  }
}
